export default __webpack_public_path__ + "static/media/PlayH8.a78800ef.png";